// i18n catalogs (architecture.md §18). react-i18next consumes these on the client;
// the server localises messages by recipient locale.
import en from './en.json' with { type: 'json' };
import bn from './bn.json' with { type: 'json' };

export const resources = {
  en: { translation: en },
  bn: { translation: bn },
};

export const defaultNS = 'translation';
export { en, bn };
